<template>
    <div>
        <div id="Show-form">
            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Admission Form #{{ display_admission_form_no }}</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br>                   
                <span v-if="tenant == 'sbpps' || tenant == 'eps'">
                    <v-tabs v-model="tab" background-color="#4b89ac" slider-color="#C89933" optional icons-and-text="true" centered class="custom-tabs" active-class="active-tab">
                        <v-tab class="normalize font-weight-bold" v-for="item in filteredTabs" :key="item.tabname" style="text-transform: capitalize;">
                            <template>
                                {{ item.tabname }}
                            </template>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="item in filteredTabs" :key="item.tabname">
                            <v-card flat color="admission-color">
                                <v-card-text>
                                    <component v-bind:is="item.component"></component>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </span>
                <span v-else-if="tenant == 'sanjivani'|| tenant == 'eps'">
                    <v-tabs v-model="tab" background-color="#4b89ac" slider-color="#C89933" optional icons-and-text="true" centered active-class="active">
                        <v-tab class="normalize font-weight-bold" v-for="item in items_sanjivani" :key="item.tabname" style="text-transform: capitalize;">
                            <template>
                                {{ item.tabname }}
                            </template>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="item in items_sanjivani" :key="item.tabname">
                            <v-card flat color="admission-color">
                                <v-card-text>
                                    <component v-bind:is="item.component"></component>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </span>
                <span v-else-if="tenant == 'desschool' && allotmentApplicable">
                    <v-tabs v-model="tab" background-color="#4b89ac" slider-color="#C89933" optional icons-and-text="true" centered active-class="active">
                        <v-tab class="normalize font-weight-bold" v-for="item in items_desschool_allotment" :key="item.tabname" style="text-transform: capitalize;"
                          v-if="!(item.tabname == '7.Subject Registration' && Subject_Registration_Tab)">
                            <template>
                                {{ item.tabname }}
                            </template>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="item in items_desschool_allotment" :key="item.tabname" v-if="!(item.tabname == '7.Subject Registration' && Subject_Registration_Tab)">
                            <v-card flat color="admission-color">
                                <v-card-text>
                                    <component v-bind:is="item.component"></component>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </span>
                 <span v-else>
                    <v-tabs v-model="tab" background-color="#4b89ac" slider-color="#C89933" optional icons-and-text="true" centered active-class="active">
                        <v-tab class="normalize font-weight-bold" v-for="item in items" :key="item.tabname" style="text-transform: capitalize;">
                            <template v-if="tenant == 'uwws' && item.tabname == 'Contact Details'">Emergency </template>
                            <template v-if="tenant == 'uwws' && item.tabname == '2.Parent Details'">2.Family Details </template>
                            <template v-else-if="tenant == 'uwws' && item.tabname == '3.Contact Details'">3.Guardian Details </template>
                            <template v-else>
                                {{ item.tabname }}
                            </template>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="item in items" :key="item.tabname">
                            <v-card flat color="admission-color">
                                <v-card-text>
                                    <component v-bind:is="item.component"></component>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </span>
            </v-card>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import Profile from "./Profile";
    import Contact from "./Contact";
    import ContactDetailsSBPPS from "./ContactDetailsSBPPS";
    import AddressDetails from "./AddressDetails";
    import AddressDetailsSBPPS from "./AddressDetailsSBPPS";
    import FamilyDetails from "./FamilyDetails";
    import LastSchoolAttended from "./LastSchoolAttended";
    import UploadDocuments from "./UploadDocuments";
    import ViewForm from "./ViewForm";
    import ParentFeeHistory from "../AccountingAndFees/Parent/ParentFeeHistory";
    import StudentMedicalDetails from "./StudentMedicalDetails";
    import FamilyDetailsSbpps from "./FamilyDetailsSbpps";
    import TransportDetails from "./TransportDetails";
    import CanteenDetails from "./CanteenDetails";
    import SubjectRegistrationDetails from "./SubjectRegistrationDetails";
    import SubjectRegistrationDetailsSBPPS from "./SubjectRegistrationDetailsSBPPS";
    import SubjectRegistrationDES from "./SubjectRegistrationDES.vue";


    export default {
        components: {
            "comp-profile": Profile,
            "comp-contact": Contact,
            "comp-contact-details-sbpps": ContactDetailsSBPPS,
            "comp-address-details": AddressDetails,
            "comp-address-details-sbpps": AddressDetailsSBPPS,
            "comp-family-details": FamilyDetails,
            "comp-family-details-sbpps": FamilyDetailsSbpps,
            "comp-last-school-attended": LastSchoolAttended,
            "comp-upload-documents": UploadDocuments,
            "comp-view-form": ViewForm,
            "parent-fee-history": ParentFeeHistory,
            "comp-stud-medical-details": StudentMedicalDetails,
            "comp-stud-transport-details": TransportDetails,
            "comp-stud-canteen-details": CanteenDetails,
            "subject-registration-details": SubjectRegistrationDetails,
            "subject-registration-details-sbpps": SubjectRegistrationDetailsSBPPS,
            "subject-registration-details-desschool": SubjectRegistrationDES,
        },
        data() {
            return {
                standardName:"",
                tenant:null,
                tab: null,
                rotate: 0,
                indeterminate: false,
                items: [
                    {
                        icon: "mdi-account-circle-outline",
                        tabname: "Student Details",
                        component: "comp-profile",
                    },
                     {
                        icon: "mdi-account-group-outline",
                        tabname: "Parent Details",
                        component: "comp-family-details",
                    },
                    {
                        icon: "mdi-phone-classic",
                        tabname: "Contact Details",
                        component: "comp-contact",
                    },
                    {
                        icon: "mdi-card-account-details",
                        tabname: "Address Details",
                        component: "comp-address-details",
                    },                   
                    {
                        icon: "mdi-school",
                        tabname: "Previous School Attended",
                        component: "comp-last-school-attended",
                    },
                    {
                        icon: "mdi-cloud-upload-outline",
                        tabname: "Upload Documents",
                        component: "comp-upload-documents",
                    },
                ],
                 items_desschool_allotment: [
                    {
                        icon: "mdi-account-circle-outline",
                        tabname: "1.Student Details",
                        component: "comp-profile",
                    },
                    {
                        icon: "mdi-account-group-outline",
                        tabname: "2.Parent Details",
                        component: "comp-family-details",
                    },
                    {
                        icon: "mdi-phone-classic",
                        tabname: "3.Contact Details",
                        component: "comp-contact",
                    },
                    {
                        icon: "mdi mdi-home",
                        tabname: "4.Address Details",
                        component: "comp-address-details",
                    },

                    {
                        icon: "mdi-school",
                        tabname: "5.Previous School Attended",
                        component: "comp-last-school-attended",
                    },
                    {
                        icon: "mdi-cloud-upload-outline",
                        tabname: "6.Upload Documents",
                        component: "comp-upload-documents",
                    },
                    {
                        icon: "mdi-book",
                        tabname: "7.Subject Registration",
                        component: "subject-registration-details-desschool",
                    },
                    // {
                    //     icon: "mdi-download",
                    //     tabname: "View Form",
                    //     component: "comp-view-form",
                    // },
                ],
                reload_comp: false,
                form_progress: 0,
                enable_submit: false,
                admission_form_no: "",
                display_admission_form_no:"",
                admission_form_id: "",
                to_show: "", //Show-Form or Form-List
                form_list: null,
                comp_load: "",
                search: "",
                allotmentApplicable: false,
                Subject_Registration_Tab : false,
                headers: [
                    { text: "# Form", value: "admission_form_no" },
                    { text: "Application date", value: "application_date" },
                    { text: "Status", value: "applicationstatus" },
                    { text: "Standard", value: "standard" },
                    { text: "Name", value: "fullname" },
                    { text: "Progress", value: "form_progress" },
                    { text: "Actions", value: "action", sortable: false },
                ],
                 items_sbpps: [
                    {
                        icon: "mdi-account-circle-outline",
                        tabname: "1.Student Details",
                        component: "comp-profile",
                    },
                    {
                        icon: "mdi-account-group-outline",
                        tabname: "2.Parent Details",
                        component: "comp-family-details-sbpps", 
                    },
                    {
                        icon: "mdi-phone-classic",
                        tabname: "3.Guardian Details",
                        component: "comp-contact-details-sbpps",
                    },
                    {
                        icon: "mdi mdi-home",
                        tabname: "4.Address Details",
                        component: "comp-address-details-sbpps",
                    },

                    {
                        icon: "mdi-school",
                        tabname: "5.Previous School Attended",
                        component: "comp-last-school-attended",
                    },
                    {
                        icon: "mdi-stethoscope",
                        tabname: "6.Medical Details",
                        component: "comp-stud-medical-details",
                    },
                    {
                        icon: "mdi-bus",
                        tabname: "7.Transport Details",
                        component: "comp-stud-transport-details",
                    },
                    {
                        icon: "mdi-food",
                        tabname: "8.Canteen Details",
                        component: "comp-stud-canteen-details",
                    },
                    {
                        icon: "mdi-book",
                        tabname: "9.Subject Registration",
                        component: "subject-registration-details-sbpps",
                    },
                    {
                        icon: "mdi-cloud-upload-outline",
                        tabname: "10.Upload Documents",
                        component: "comp-upload-documents",
                    },
                ],
                items_sanjivani: [
                    {
                        icon: "mdi-account-circle-outline",
                        tabname: "1.Student Details",
                        component: "comp-profile",
                    },
                    {
                        icon: "mdi-account-group-outline",
                        tabname: "2.Parent Details",
                        component: "comp-family-details",
                    },
                    {
                        icon: "mdi-phone-classic",
                        tabname: "3.Contact Details",
                        component: "comp-contact",
                    },
                    {
                        icon: "mdi mdi-home",
                        tabname: "4.Address Details",
                        component: "comp-address-details",
                    },
                    {
                        icon: "mdi-school",
                        tabname: "5.Previous School Attended",
                        component: "comp-last-school-attended",
                    },
                    {
                        icon: "mdi-stethoscope",
                        tabname: "6.Medical Details",
                        component: "comp-stud-medical-details",
                    },
                    {
                        icon: "mdi-bus",
                        tabname: "7.Transport Details",
                        component: "comp-stud-transport-details",
                    },
                    {
                        icon: "mdi-cloud-upload-outline",
                        tabname: "8.Upload Documents",
                        component: "comp-upload-documents",
                    },
                    {
                        icon: "mdi-book",
                        tabname: "9.Subject Registration",
                        component: "subject-registration-details",
                    },
                ],
            };
        },
         created() {
            this.tenant = localStorage.getItem("EPS-tenant");
            this.allotmentApplicable = localStorage.getItem("allotmentApplicable") === "true";
            console.log("allotemnt============="+this.allotmentApplicable);
            this.Subject_Registration_Tab = localStorage.getItem("Subject_Registration_Tab") === "true";
             console.log("Subject_Registration_Tab============="+this.Subject_Registration_Tab);
        },
        mounted() {
            this.admission_form_no = this.$store.getters.application_form_data.admission_form_no;
            this.display_admission_form_no = this.$store.getters.application_form_data.display_admission_form_no;
            this.standardName=this.$store.getters.application_form_data.standardName;
            this.tab = 0;
            //alert("standardName--"+this.standardName)
        },
        computed: {
            filteredTabs() {
                // Define the standards that should show "9. Subject Registration"
                const allowedStandards = ["XI (Comm)", "XI (Sci)", "XII (Comm)", "XII (Sci)", "XI (Humanities)"];

                // Filter out "9. Subject Registration" if the standardName is empty or not in the allowed list
                let filteredTabs = this.items_sbpps.filter(item => {
                    if (item.tabname === "9.Subject Registration") {
                        return this.standardName && allowedStandards.includes(this.standardName);
                    }
                    return true;
                });

                // Find the index of "10. Upload Documents" and update its tab number if necessary
                const uploadDocumentsIndex = filteredTabs.findIndex(item => item.tabname === "10.Upload Documents");

                if (uploadDocumentsIndex !== -1) {
                    const subjectRegistrationExists = filteredTabs.some(item => item.tabname === "9.Subject Registration");

                    // If "9.Subject Registration" is removed, update "10.Upload Documents" to "9.Upload Documents"
                    if (!subjectRegistrationExists) {
                        filteredTabs[uploadDocumentsIndex] = {
                            ...filteredTabs[uploadDocumentsIndex],
                            tabname: "9.Upload Documents"
                        };
                    }
                }

                return filteredTabs;
                        }
            },

    };
</script>
<style scoped>
 .active {
        color: #222222;
        background-color: #ffff;
    }
.custom-tabs .v-tab {
    color: white !important;
}

.custom-tabs .v-tab .v-icon {
    color: white !important;
}

.custom-tabs .v-tab.active-tab {
    color: black !important;
    background-color: #ffff;
}

.custom-tabs .v-tab.active-tab .v-icon {
    color: black !important;
    background-color: #ffff;
}
</style>
